export class ContextualMenuOpenEvent {
	constructor(
		public sourceEvent: MouseEvent,
		public index: number
	) {}
}
